export const createSectionNumberCounter = () => {
  let sectionNumber = 0;
  return () => String(++sectionNumber);
};
